export default __webpack_public_path__ + "static/media/the_san_andreas.9b0556bd.jpg";